import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

const getColor = (
  type: 'bgColor' | 'color',
  isMultiLevel: boolean,
  isCompleted: boolean
) => {
  if (type === 'bgColor') {
    return !isMultiLevel && !isCompleted
      ? colors.gray.gray90
      : !isMultiLevel && isCompleted
      ? colors.yellow
      : 'transparent'
  }

  return isMultiLevel
    ? colors.yellow
    : !isMultiLevel && isCompleted
    ? colors.black
    : colors.gray.gray60
}

export const CommunityBadgeAchCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(2),
  margin: theme.spacing(2),
  borderRadius: 12,
  background: colors.gray.gray90,
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  '& .communityFeaturedImgCon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '25%',
    '& .communityFeaturedImg': {
      width: '100%',
    },
  },
  '& .achItemCon': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(0, 2),
    width: '75%',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0, 1),
    },
  },
}))

type CheckStylesProps = {
  completed: boolean
}

export const AchievementInfoCon = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: theme.spacing(0, 1, 1),
  '& .progressCon': {
    display: 'flex',
    flexDirection: 'row',
    margin: theme.spacing(3, 0),
    '& .progressTitle': {
      color: colors.white,
      fontSize: fontSizes.semiLarge,
      fontWeight: 'bold',
      margin: theme.spacing(0, 1),
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '& .progress': {
      color: colors.yellow,
      fontSize: fontSizes.semiLarge,
      fontWeight: 'bold',
      margin: theme.spacing(0, 1),
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
  '& .achRight': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
}))

export const BarCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  margin: theme.spacing(1),
}))

export const LevelsCon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}))

export const ActionsCon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

type HeaderRightParams = {
  isMultiLevel: boolean
  isCompleted: boolean
}

export const HeaderRightCon = styled('div')<HeaderRightParams>(
  ({ theme, isMultiLevel, isCompleted }) => ({
    marginLeft: theme.spacing(1),
    margin: theme.spacing(0.5, 0, 1, 1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5),
    borderRadius: 6,
    fontWeight: 'bold',
    backgroundColor: getColor('bgColor', isMultiLevel, isCompleted),
    color: getColor('color', isMultiLevel, isCompleted),
    fontSize: isMultiLevel ? fontSizes.small : fontSizes.xSmall,
  })
)

export const PrizeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  width: '100%',
  '& .prizeItem': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '25%',
    borderRadius: 6,
    padding: theme.spacing(0, 1),
    [theme.breakpoints.down('md')]: {
      width: '30%',
    },
    '& h3': {
      textAlign: 'center',
      color: colors.white,
      fontSize: fontSizes.xSmall,
      fontWeight: 'bold',
    },
    '& p': {
      textAlign: 'center',
      color: colors.gray.gray40,
      fontSize: fontSizes.small,
      marginTop: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
    '& img': {
      borderRadius: 8,
      width: 150,
      height: 150,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
        width: 75,
        height: 75,
      },
    },
  },
}))

export const LevelProgressCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: theme.spacing(-8.5),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(-5.75),
  },
}))

export const LevelCircleCon = styled('div')<CheckStylesProps>(
  ({ theme, completed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: completed ? colors.yellow : colors.gray.gray20,
    borderRadius: '50%',
    width: 40,
    height: 40,
    [theme.breakpoints.down('md')]: {
      width: 25,
      height: 25,
    },
    '& .levelText': {
      color: completed ? colors.black : colors.gray.gray70,
      fontSize: fontSizes.small,
      fontWeight: 'bold',
      margin: 0, 
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  })
)
